import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PAYMENTPAGEHEADERBLOCKCOMPONENT_LEGACY_FIELD_ORDER = [
  "back_link_url",
  "text_color",
  "background_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  paymentPageHeaderBlockDescriptor: _generatedPaymentPageHeaderBlockDescriptor,
  paymentPageHeaderBlockBlocDefinition,
  paymentPageHeaderBlockDashboardLayout,
  paymentPageHeaderBlockConfig,
  paymentPageHeaderBlockResolveConfig,
  paymentPageHeaderBlockProperties,
} = doodBlockConfig(
  {
    name: "Payment page - Header",
    componentType: 'PaymentPageHeaderBlockComponent',
    category: 'navigation',
    description: "Payment page - Header.",
    keywords: [],
    allowedIn: [{ bloc: 'PaymentPageComponent', slot: 'body' }],
    sharedFields: {}
  },

  () => ({
    back_link_url: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.payment-page-header.back-link-url.label",
        help: "pages.blocks.payment-page-header.back-link-url.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-900"},
      options: {
        label: "pages.blocks.payment-page-header.text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.payment-page-header.background-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.payment-page-header.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.payment-page-header.fieldset.header.label",
            fields: ["back_link_url", "text_color", "background_color"],
          },
        ],
      },
    ],
  })
);

export function paymentPageHeaderBlockDescriptor(): IBlockDescriptor;
export function paymentPageHeaderBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function paymentPageHeaderBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPaymentPageHeaderBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPaymentPageHeaderBlockDescriptor, paymentPageHeaderBlockProperties, fieldOrder);
}

export {
  paymentPageHeaderBlockBlocDefinition,
  paymentPageHeaderBlockDashboardLayout,
  paymentPageHeaderBlockProperties,
  paymentPageHeaderBlockConfig,
  paymentPageHeaderBlockResolveConfig,
};

export type PaymentPageHeaderBlockConfig = typeof paymentPageHeaderBlockConfig;
